import { ContactPerson } from "../models/generic";

export const MembershipTeam: ContactPerson = {
    address: "members@asrs.org",
    name: "Membership Team",
};

export const StacyKiff: ContactPerson = {
    address: "stacy.kiff@asrs.org",
    name: "Stacy Kiff",
    phone: "(312) 477-8863",
    title: "ASRS Vice President of Education",
};



// WEBPACK FOOTER //
// ./src/constants/contacts.ts